import styled from 'styled-components';

const PrivacyPolicyContainer = styled.div`
  margin: 40px;
`;

const Heading = styled.h1`
  margin-bottom: 12px;
`;

const Paragraph = styled.p`
  padding: 10px 0;
  line-height: 22px;
`;

const OrderedList = styled.ol`
  margin-left: 12px;
  padding-top: 12px;
`;

const ListItem = styled.li`
  margin-left: 20px;
`;

const TextWrapper = styled.div`
  flex: 8;
`;

const InteractiveTextWrapper = styled.div`
  flex: 1;
  justify-content: flex-end;
  align-self: flex-start;
`;

const OpenModalButtonText = styled.button`
  text-decoration: underline;
  background-color: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
`;

export {
  PrivacyPolicyContainer,
  Heading,
  Paragraph,
  OrderedList,
  ListItem,
  TextWrapper,
  InteractiveTextWrapper,
  OpenModalButtonText,
};
